var React = require('react');

function ScrollDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".arrow-down{fill:none;stroke:#32f06e;stroke-miterlimit:10;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Diseño"},[React.createElement("circle",{"className":"arrow-down","cx":"19.35","cy":"19.35","r":"18.85","key":0}),React.createElement("polyline",{"className":"arrow-down","points":"29.42 15.7 19.07 26.04 8.72 15.7","key":1})]))]);
}

ScrollDown.defaultProps = {"viewBox":"0 0 38.71 38.71"};

module.exports = ScrollDown;

ScrollDown.default = ScrollDown;
